/*
 * Drømmemøbler – «Se møbelet på din terrasse»
 * Kunden laster opp et bilde av sin egen terrasse og plasserer produktet i bildet.
 * Alt skjer i nettleseren: bildet lastes aldri opp til noen server.
 *
 * Bruk: <div data-dm-plasser='{"title":"…","widthCm":86,"images":[{"src":"…","cut":true,"label":"Forfra"}]}'></div>
 *   cut:true  = bildet er allerede frilagt (PNG med gjennomsiktig bakgrunn)
 *   cut:false = produktbilde på hvit bakgrunn; den hvite bakgrunnen fjernes automatisk
 */
(function () {
  'use strict';
  if (window.DMPlasser) return;

  var MAX_BG = 2400;          // lengste side på kundens bilde etter nedskalering
  var HANDLE = 15;            // håndtakets radius i CSS-piksler
  var HIT = 26;               // treffsone for håndtak

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  var ICON = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    flip: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v18M8 7L3 12l5 5V7zM16 7l5 5-5 5V7z"/></svg>',
    copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h3"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 16L16 3l5 5L8 21z"/><path d="M7 12l2 2M10 9l2 2M13 6l2 2"/></svg>',
    save: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5M5 20h14"/></svg>',
    share: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15V4M8 8l4-4 4 4M5 13v6h14v-6"/></svg>',
    photo: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h3l2-3h6l2 3h3v13H4z"/><circle cx="12" cy="13" r="4"/></svg>',
    sliders: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg>'
  };

  /* ---------- Bildehjelpere ---------- */

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function toCanvas(img, maxSide) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var k = maxSide ? Math.min(1, maxSide / Math.max(w, h)) : 1;
    var c = document.createElement('canvas');
    c.width = Math.round(w * k); c.height = Math.round(h * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c;
  }

  // Beskjær til synlige piksler
  function trim(c) {
    var ctx = c.getContext('2d'), d = ctx.getImageData(0, 0, c.width, c.height).data;
    var minX = c.width, minY = c.height, maxX = -1, maxY = -1;
    for (var y = 0; y < c.height; y++) for (var x = 0; x < c.width; x++) {
      if (d[(y * c.width + x) * 4 + 3] > 12) {
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
    if (maxX < 0) return c;
    var o = document.createElement('canvas');
    o.width = maxX - minX + 1; o.height = maxY - minY + 1;
    o.getContext('2d').drawImage(c, -minX, -minY);
    return o;
  }

  // Fjerner ensfarget lys bakgrunn (hvit eller lys grå studiobakgrunn) fra et produktbilde.
  // Returnerer null hvis bildet ikke har en slik bakgrunn (for eksempel et miljøbilde).
  function removeWhite(c) {
    var w = c.width, h = c.height, ctx = c.getContext('2d');
    var id = ctx.getImageData(0, 0, w, h), d = id.data, i, x, y;
    // Bakgrunnsfarge = median av kantpikslene
    var rs = [], gs = [], bs = [];
    function sample(px) { var j = px * 4; rs.push(d[j]); gs.push(d[j + 1]); bs.push(d[j + 2]); }
    for (x = 0; x < w; x += 3) { sample(x); sample((h - 1) * w + x); }
    for (y = 0; y < h; y += 3) { sample(y * w); sample(y * w + w - 1); }
    function med(a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
    var R = med(rs.slice()), G = med(gs.slice()), B = med(bs.slice());
    if (Math.min(R, G, B) < 200) return null;              // bare lyse studiobakgrunner
    function dist(j) { var a = d[j] - R, b = d[j + 1] - G, e = d[j + 2] - B; return Math.sqrt(a * a + b * b + e * e); }
    var near = 0;
    for (i = 0; i < rs.length; i++) {
      var a = rs[i] - R, b = gs[i] - G, e = bs[i] - B;
      if (Math.sqrt(a * a + b * b + e * e) < 20) near++;
    }
    if (near / rs.length < 0.85) return null;

    var TOL = 16;
    var seen = new Uint8Array(w * h), stack = [];
    function push(px) { if (!seen[px] && dist(px * 4) < TOL) { seen[px] = 1; stack.push(px); } }
    for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (stack.length) {
      var p = stack.pop(), px = p % w, py = (p - px) / w;
      if (px > 0) push(p - 1); if (px < w - 1) push(p + 1);
      if (py > 0) push(p - w); if (py < h - 1) push(p + w);
    }
    // Hull i flettverk o.l.: små lukkede felt med nesten nøyaktig bakgrunnsfarge
    var lab = new Int32Array(w * h), maxHole = w * h * 0.004;
    for (i = 0; i < w * h; i++) {
      if (seen[i] || lab[i] || dist(i * 4) >= 7) continue;
      var comp = [i]; lab[i] = 1; var k = 0;
      while (k < comp.length && comp.length <= maxHole) {
        var q = comp[k++], qx = q % w;
        var nb = [qx > 0 ? q - 1 : -1, qx < w - 1 ? q + 1 : -1, q - w, q + w];
        for (var n = 0; n < 4; n++) {
          var t = nb[n];
          if (t < 0 || t >= w * h || seen[t] || lab[t] || dist(t * 4) >= 7) continue;
          lab[t] = 1; comp.push(t);
        }
      }
      if (comp.length <= maxHole && comp.length >= 6) for (k = 0; k < comp.length; k++) seen[comp[k]] = 1;
    }
    for (i = 0; i < w * h; i++) if (seen[i]) d[i * 4 + 3] = 0;
    // Myk kant mot bakgrunnen
    for (y = 1; y < h - 1; y++) for (x = 1; x < w - 1; x++) {
      var r = y * w + x;
      if (seen[r]) continue;
      if (seen[r - 1] || seen[r + 1] || seen[r - w] || seen[r + w]) {
        var dj = dist(r * 4);
        d[r * 4 + 3] = dj < 30 ? 90 : 210;
      }
    }
    ctx.putImageData(id, 0, 0);
    return trim(c);
  }

  // Finner bredden i produktbeskrivelsen: «Bredde: 86 cm» eller «B x D x H: 86 x 80 x 75 cm»
  function parseWidth(t) {
    t = String(t).replace(/\s+/g, ' ');
    var m = t.match(/bredde[^0-9]{0,25}(\d{2,3}(?:[.,]\d)?)\s*cm/i);
    if (!m) m = t.match(/\bB\s*[x×]\s*D\s*[x×]\s*H[^0-9]{0,15}(\d{2,3}(?:[.,]\d)?)/i);
    var v = m ? parseFloat(m[1].replace(',', '.')) : 0;
    return v >= 20 && v <= 600 ? v : 0;
  }

  /* ---------- Hovedkomponent ---------- */

  function DMPlasser(root, cfg) {
    this.root = root;
    this.cfg = cfg || {};
    this.cfg.images = (this.cfg.images || []).filter(function (x) { return x && x.src; });
    if (!this.cfg.widthCm && this.cfg.dimText) this.cfg.widthCm = parseWidth(this.cfg.dimText);
    this.items = [];
    this.sel = null;
    this.pointers = {};
    this.cutouts = [];
    this.bg = null;
    this.mode = null;
    this.measure = null;
    this.pxPerCm = null;
    this.buildTrigger();
  }

  DMPlasser.prototype.buildTrigger = function () {
    var self = this;
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var b = el('button', 'dmp-trigger', ICON.photo + '<span><b>' + esc(this.cfg.label || 'Se den på din terrasse') + '</b><small>' + esc(this.cfg.sub || 'Last opp et bilde og plasser møbelet') + '</small></span>');
    b.type = 'button';
    b.addEventListener('click', function () { self.open(); });
    this.root.appendChild(b);
    // Har vi bare vanlige produktbilder (ikke frilagte), vises knappen først når
    // minst ett av dem har hvit bakgrunn som lar seg fjerne.
    var anyCut = this.cfg.images.some(function (x) { return x.cut; });
    if (!anyCut) {
      b.hidden = true;
      var go = function () { self.prepareCutouts().then(function (l) { if (l.length) b.hidden = false; }); };
      if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
    }
  };

  DMPlasser.prototype.buildModal = function () {
    var self = this, cfg = this.cfg;
    var m = el('div', 'dmp-modal');
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Se møbelet på din terrasse');
    m.innerHTML =
      '<div class="dmp-head">' +
        '<div class="dmp-title"><b>Se den på din terrasse</b><span></span></div>' +
        '<button type="button" class="dmp-icon dmp-close" aria-label="Lukk">' + ICON.close + '</button>' +
      '</div>' +
      '<div class="dmp-stage">' +
        '<canvas class="dmp-canvas" aria-label="Ditt bilde med møbelet"></canvas>' +
        '<div class="dmp-empty">' +
          '<div class="dmp-empty-in">' +
            '<p class="dmp-empty-h">Ta et bilde av terrassen din</p>' +
            '<ul class="dmp-tips">' +
              '<li><b>Stå der du ser plassen fra</b> til vanlig, for eksempel i terrassedøra, og hold telefonen i brysthøyde.</li>' +
              '<li><b>Hold telefonen rett</b> og ta bildet liggende, med hele plassen og litt rundt.</li>' +
              '<li><b>Dagslys</b> gir best resultat. Unngå sterk sol rett mot kameraet.</li>' +
              (cfg.widthCm ? '<li><b>Få med noe du vet målet på</b>, som en dør eller et terrassebord, så kan møbelet få riktig størrelse.</li>' : '') +
            '</ul>' +
            '<label class="dmp-btn dmp-btn-main">' + ICON.photo + '<span>Velg eller ta bilde</span><input type="file" accept="image/*" hidden></label>' +
            '<p class="dmp-privacy">Bildet ditt blir på din telefon eller PC. Det lastes ikke opp til oss eller andre.</p>' +
          '</div>' +
        '</div>' +
        '<div class="dmp-hint" hidden></div>' +
        '<div class="dmp-loading" hidden>Gjør klar møbelet …</div>' +
      '</div>' +
      '<div class="dmp-panel" hidden>' +
        '<div class="dmp-row dmp-thumbs" aria-label="Velg vinkel"></div>' +
        '<div class="dmp-sliders" hidden>' +
          '<label>Størrelse<input type="range" data-k="scale" min="0.05" max="3" step="0.01"></label>' +
          '<label>Dreie<input type="range" data-k="rot" min="-45" max="45" step="0.5"></label>' +
          '<label>Perspektiv<input type="range" data-k="tilt" min="0" max="0.45" step="0.01"></label>' +
          '<label>Lys<input type="range" data-k="light" min="-0.45" max="0.45" step="0.01"></label>' +
          '<label class="dmp-check"><input type="checkbox" data-k="shadow"> Skygge under møbelet</label>' +
        '</div>' +
        '<div class="dmp-row dmp-tools">' +
          '<button type="button" class="dmp-tool" data-a="adjust">' + ICON.sliders + '<span>Juster</span></button>' +
          '<button type="button" class="dmp-tool" data-a="flip">' + ICON.flip + '<span>Speilvend</span></button>' +
          '<button type="button" class="dmp-tool" data-a="copy">' + ICON.copy + '<span>Legg til</span></button>' +
          '<button type="button" class="dmp-tool" data-a="delete">' + ICON.trash + '<span>Fjern</span></button>' +
          (cfg.widthCm ? '<button type="button" class="dmp-tool" data-a="measure">' + ICON.ruler + '<span>Riktig mål</span></button>' : '') +
          '<label class="dmp-tool">' + ICON.photo + '<span>Nytt bilde</span><input type="file" accept="image/*" hidden></label>' +
        '</div>' +
        '<div class="dmp-row dmp-out">' +
          '<button type="button" class="dmp-btn" data-a="save">' + ICON.save + '<span>Lagre bilde</span></button>' +
          '<button type="button" class="dmp-btn dmp-btn-main" data-a="share" hidden>' + ICON.share + '<span>Del bildet</span></button>' +
        '</div>' +
      '</div>' +
      '<form class="dmp-measure" hidden>' +
        '<p>Hvor lang er streken du tegnet?</p>' +
        '<div><input type="number" inputmode="decimal" min="5" max="2000" step="1" required aria-label="Lengde i centimeter"><span>cm</span></div>' +
        '<small>Tips: mål en dør (ofte 80–90 cm), et terrassebord eller en flis som står like ved der møbelet skal stå.</small>' +
        '<div class="dmp-measure-btns"><button type="button" class="dmp-btn" data-a="measure-cancel">Avbryt</button><button type="submit" class="dmp-btn dmp-btn-main">Bruk målet</button></div>' +
      '</form>';

    m.querySelector('.dmp-title span').textContent = cfg.title || '';
    document.body.appendChild(m);
    this.m = m;
    this.canvas = m.querySelector('.dmp-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.stage = m.querySelector('.dmp-stage');
    this.hintEl = m.querySelector('.dmp-hint');

    m.querySelector('.dmp-close').addEventListener('click', function () { self.close(); });
    Array.prototype.forEach.call(m.querySelectorAll('input[type=file]'), function (inp) {
      inp.addEventListener('change', function () {
        if (inp.files && inp.files[0]) self.loadBackground(inp.files[0]);
        inp.value = '';
      });
    });
    m.addEventListener('click', function (e) {
      var t = e.target.closest('[data-a]');
      if (t) self.action(t.getAttribute('data-a'));
    });
    Array.prototype.forEach.call(m.querySelectorAll('.dmp-sliders input'), function (inp) {
      inp.addEventListener('input', function () {
        if (!self.sel) return;
        var k = inp.getAttribute('data-k');
        if (k === 'shadow') self.sel.shadow = inp.checked;
        else if (k === 'rot') self.sel.rot = (+inp.value) * Math.PI / 180;
        else self.sel[k] = +inp.value;
        if (k === 'light') self.sel.tinted = null;
        self.draw();
      });
    });
    m.querySelector('.dmp-measure').addEventListener('submit', function (e) {
      e.preventDefault(); self.applyMeasure();
    });

    if (navigator.canShare) {
      try {
        var test = new File(['x'], 'x.jpg', { type: 'image/jpeg' });
        if (navigator.canShare({ files: [test] })) m.querySelector('[data-a=share]').hidden = false;
      } catch (e) { /* ikke støttet */ }
    }

    var c = this.canvas;
    c.addEventListener('pointerdown', function (e) { self.onDown(e); });
    c.addEventListener('pointermove', function (e) { self.onMove(e); });
    c.addEventListener('pointerup', function (e) { self.onUp(e); });
    c.addEventListener('pointercancel', function (e) { self.onUp(e); });
    c.addEventListener('wheel', function (e) { self.onWheel(e); }, { passive: false });
    this.onKey = function (e) { self.key(e); };
    this.onResize = function () { self.resize(); };
  };

  DMPlasser.prototype.open = function () {
    if (!this.m) this.buildModal();
    this.m.classList.add('is-open');
    document.documentElement.classList.add('dmp-lock');
    document.addEventListener('keydown', this.onKey);
    window.addEventListener('resize', this.onResize);
    this.resize();
    var self = this;
    this.prepareCutouts().then(function () { self.renderThumbs(); });
    try { document.dispatchEvent(new CustomEvent('dm-plasser:open', { detail: { title: this.cfg.title } })); } catch (e) {}
  };

  DMPlasser.prototype.close = function () {
    this.m.classList.remove('is-open');
    document.documentElement.classList.remove('dmp-lock');
    document.removeEventListener('keydown', this.onKey);
    window.removeEventListener('resize', this.onResize);
  };

  // Laster produktbildene og gjør dem klare (frilagt)
  DMPlasser.prototype.prepareCutouts = function () {
    if (this.cutoutsPromise) return this.cutoutsPromise;
    var self = this;
    this.cutoutsPromise = Promise.all(this.cfg.images.map(function (im) {
      return loadImage(im.src).then(function (img) {
        var c = toCanvas(img, 1400);
        var out = im.cut ? trim(c) : removeWhite(c);
        return out ? { canvas: out, label: im.label || '', thumb: im.thumb || im.src } : null;
      }).catch(function () { return null; });
    })).then(function (list) {
      self.cutouts = list.filter(Boolean);
      self.renderThumbs();
      return self.cutouts;
    });
    return this.cutoutsPromise;
  };

  DMPlasser.prototype.renderThumbs = function () {
    if (!this.m) return;
    var self = this, box = this.m.querySelector('.dmp-thumbs');
    box.innerHTML = '';
    box.hidden = this.cutouts.length < 2;
    this.cutouts.forEach(function (co, i) {
      var b = el('button', 'dmp-thumb');
      b.type = 'button';
      b.setAttribute('aria-label', co.label ? 'Vis ' + co.label : 'Vinkel ' + (i + 1));
      var t = document.createElement('canvas');
      var k = 56 / Math.max(co.canvas.width, co.canvas.height);
      t.width = Math.round(co.canvas.width * k); t.height = Math.round(co.canvas.height * k);
      t.getContext('2d').drawImage(co.canvas, 0, 0, t.width, t.height);
      b.appendChild(t);
      if (co.label) b.appendChild(el('span', null, co.label));
      b.addEventListener('click', function () { self.setCutout(i); });
      box.appendChild(b);
    });
  };

  DMPlasser.prototype.setCutout = function (i) {
    if (!this.sel) { this.addItem(i); return; }
    var it = this.sel, co = this.cutouts[i];
    var oldW = it.w * it.scale;
    it.co = i; it.w = co.canvas.width; it.h = co.canvas.height; it.tinted = null;
    it.scale = oldW / it.w;   // behold bredden
    this.syncUI(); this.draw();
  };

  DMPlasser.prototype.loadBackground = function (file) {
    var self = this;
    var done = function (src) {
      self.bg = toCanvas(src, MAX_BG);
      self.m.querySelector('.dmp-empty').hidden = true;
      self.m.querySelector('.dmp-panel').hidden = false;
      self.resize();
      self.m.querySelector('.dmp-loading').hidden = false;
      self.prepareCutouts().then(function () {
        self.m.querySelector('.dmp-loading').hidden = true;
        if (!self.cutouts.length) { self.hint('Fant ikke et frilagt bilde av dette møbelet.', 6000); return; }
        if (!self.items.length) self.addItem(0);
        else self.items.forEach(function (it) { self.fitItem(it); });
        self.hint('Dra møbelet dit du vil ha det. Bruk to fingre for å dreie og endre størrelse.', 5000);
        self.draw();
      });
    };
    if (window.createImageBitmap) {
      createImageBitmap(file, { imageOrientation: 'from-image' }).then(done).catch(function () { self.loadViaImg(file, done); });
    } else this.loadViaImg(file, done);
  };

  DMPlasser.prototype.loadViaImg = function (file, done) {
    var self = this, url = URL.createObjectURL(file), img = new Image();
    img.onload = function () { done(img); URL.revokeObjectURL(url); };
    img.onerror = function () { self.hint('Kunne ikke åpne bildet. Prøv et JPG- eller PNG-bilde.', 5000); };
    img.src = url;
  };

  DMPlasser.prototype.fitItem = function (it) {
    var bg = this.bg;
    it.x = bg.width / 2; it.y = bg.height * 0.62;
    it.scale = (bg.height * 0.38) / it.h;
    if (it.w * it.scale > bg.width * 0.7) it.scale = bg.width * 0.7 / it.w;
    if (this.pxPerCm && this.cfg.widthCm) it.scale = this.cfg.widthCm * this.pxPerCm / it.w;
  };

  DMPlasser.prototype.addItem = function (coIndex, from) {
    var co = this.cutouts[coIndex];
    var it = { co: coIndex, w: co.canvas.width, h: co.canvas.height, x: 0, y: 0, scale: 1, rot: 0, flip: false, tilt: 0, light: 0, shadow: true, tinted: null };
    if (from) {
      ['scale', 'rot', 'flip', 'tilt', 'light', 'shadow'].forEach(function (k) { it[k] = from[k]; });
      it.x = from.x + from.w * from.scale * 0.6; it.y = from.y;
      if (it.x > this.bg.width) it.x = from.x - from.w * from.scale * 0.6;
    } else this.fitItem(it);
    this.items.push(it);
    this.select(it);
    this.draw();
  };

  DMPlasser.prototype.select = function (it) {
    this.sel = it;
    this.m.classList.toggle('has-sel', !!it);
    this.syncUI();
    Array.prototype.forEach.call(this.m.querySelectorAll('.dmp-thumb'), function (b, i) {
      b.classList.toggle('is-on', !!it && it.co === i);
    });
  };

  DMPlasser.prototype.syncUI = function () {
    var it = this.sel; if (!it || !this.m) return;
    var q = this.m.querySelector.bind(this.m);
    q('[data-k=scale]').value = it.scale;
    q('[data-k=scale]').max = Math.max(3, it.scale * 2);
    q('[data-k=rot]').value = it.rot * 180 / Math.PI;
    q('[data-k=tilt]').value = it.tilt;
    q('[data-k=light]').value = it.light;
    q('[data-k=shadow]').checked = it.shadow;
  };

  DMPlasser.prototype.action = function (a) {
    var it = this.sel;
    switch (a) {
      case 'adjust':
        var s = this.m.querySelector('.dmp-sliders');
        s.hidden = !s.hidden;
        this.m.querySelector('[data-a=adjust]').classList.toggle('is-on', !s.hidden);
        this.resize();
        break;
      case 'flip': if (it) { it.flip = !it.flip; this.draw(); } break;
      case 'copy':
        if (!this.cutouts.length || !this.bg) break;
        this.addItem(it ? it.co : 0, it);
        break;
      case 'delete':
        if (it) { this.items.splice(this.items.indexOf(it), 1); this.select(null); this.draw(); }
        break;
      case 'measure':
        if (!this.bg) break;
        this.mode = 'measure'; this.measure = null;
        this.hint('Tegn en strek langs noe du vet lengden på, der møbelet skal stå.', 0);
        break;
      case 'measure-cancel':
        this.mode = null; this.measure = null;
        this.m.querySelector('.dmp-measure').hidden = true; this.hint('', 1); this.draw();
        break;
      case 'save': this.exportImage(false); break;
      case 'share': this.exportImage(true); break;
    }
  };

  DMPlasser.prototype.applyMeasure = function () {
    var f = this.m.querySelector('.dmp-measure'), cm = parseFloat(f.querySelector('input').value);
    var mm = this.measure;
    if (!(cm > 0) || !mm) return;
    var len = Math.hypot(mm.b.x - mm.a.x, mm.b.y - mm.a.y);
    this.pxPerCm = len / cm;
    var target = this.sel || this.items[0];
    if (target) {
      target.scale = this.cfg.widthCm * this.pxPerCm / target.w;
      // Flytt møbelet dit streken ble tegnet
      target.x = (mm.a.x + mm.b.x) / 2;
      target.y = (mm.a.y + mm.b.y) / 2 - target.h * target.scale * (1 - target.tilt) * 0.4;
      this.select(target);
    }
    this.mode = null; this.measure = null; f.hidden = true;
    this.hint('Møbelet er nå ' + this.cfg.widthCm + ' cm bredt i bildet ditt. Størrelsen stemmer der du målte.', 5000);
    this.draw();
  };

  DMPlasser.prototype.hint = function (txt, ms) {
    var h = this.hintEl;
    clearTimeout(this.hintT);
    if (!txt) { h.hidden = true; return; }
    h.textContent = txt; h.hidden = false;
    if (ms) this.hintT = setTimeout(function () { h.hidden = true; }, ms);
  };

  /* ---------- Tegning ---------- */

  DMPlasser.prototype.resize = function () {
    if (!this.m) return;
    var r = this.stage.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    this.dpr = dpr;
    this.canvas.width = Math.max(1, Math.round(r.width * dpr));
    this.canvas.height = Math.max(1, Math.round(r.height * dpr));
    this.canvas.style.width = r.width + 'px';
    this.canvas.style.height = r.height + 'px';
    if (this.bg) {
      var k = Math.min(r.width / this.bg.width, r.height / this.bg.height);
      this.view = { k: k, ox: (r.width - this.bg.width * k) / 2, oy: (r.height - this.bg.height * k) / 2 };
    }
    this.draw();
  };

  DMPlasser.prototype.tinted = function (it) {
    var co = this.cutouts[it.co].canvas;
    if (!it.light) return co;
    if (it.tinted && it.tintedFor === it.light + ':' + it.co) return it.tinted;
    var c = document.createElement('canvas'); c.width = co.width; c.height = co.height;
    var x = c.getContext('2d');
    x.drawImage(co, 0, 0);
    x.globalCompositeOperation = 'source-atop';
    x.fillStyle = it.light > 0 ? 'rgba(255,248,235,' + it.light + ')' : 'rgba(20,24,30,' + (-it.light) + ')';
    x.fillRect(0, 0, c.width, c.height);
    it.tinted = c; it.tintedFor = it.light + ':' + it.co;
    return c;
  };

  DMPlasser.prototype.drawItem = function (ctx, it) {
    var sx = it.scale * (it.flip ? -1 : 1), sy = it.scale * (1 - it.tilt);
    ctx.save();
    ctx.translate(it.x, it.y);
    ctx.rotate(it.rot);
    if (it.shadow) {
      // Myk kontaktskygge under møbelet
      ctx.save();
      ctx.translate(0, it.h * sy / 2 - it.h * sy * 0.015);
      ctx.scale(1, 0.13 + it.tilt * 0.25);
      var rx = it.w * it.scale * 0.52;
      var g = ctx.createRadialGradient(0, 0, 0, 0, 0, rx);
      g.addColorStop(0, 'rgba(0,0,0,0.42)');
      g.addColorStop(0.55, 'rgba(0,0,0,0.22)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(0, 0, rx, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    }
    ctx.scale(sx, sy);
    ctx.drawImage(this.tinted(it), -it.w / 2, -it.h / 2);
    ctx.restore();
  };

  // Hjørner av et møbel i bildekoordinater
  DMPlasser.prototype.corners = function (it) {
    var hw = it.w * it.scale / 2, hh = it.h * it.scale * (1 - it.tilt) / 2;
    var c = Math.cos(it.rot), s = Math.sin(it.rot);
    return [[-hw, -hh], [hw, -hh], [hw, hh], [-hw, hh], [0, -hh]].map(function (p) {
      return { x: it.x + p[0] * c - p[1] * s, y: it.y + p[0] * s + p[1] * c };
    });
  };

  DMPlasser.prototype.toScreen = function (p) {
    var v = this.view; return { x: v.ox + p.x * v.k, y: v.oy + p.y * v.k };
  };
  DMPlasser.prototype.toImage = function (p) {
    var v = this.view; return { x: (p.x - v.ox) / v.k, y: (p.y - v.oy) / v.k };
  };

  DMPlasser.prototype.handles = function (it) {
    var self = this, cs = this.corners(it).map(function (p) { return self.toScreen(p); });
    var top = cs[4], ctr = this.toScreen({ x: it.x, y: it.y });
    var dx = top.x - ctr.x, dy = top.y - ctr.y, L = Math.hypot(dx, dy) || 1;
    return {
      box: cs.slice(0, 4),
      rotate: { x: top.x + dx / L * 34, y: top.y + dy / L * 34 },
      scale: cs[2]
    };
  };

  DMPlasser.prototype.draw = function () {
    if (!this.ctx) return;
    var self = this;
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(function () { self.paint(); });
  };

  DMPlasser.prototype.paint = function () {
    var ctx = this.ctx, dpr = this.dpr || 1;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    if (!this.bg || !this.view) return;
    var v = this.view, self = this;
    ctx.setTransform(dpr * v.k, 0, 0, dpr * v.k, dpr * v.ox, dpr * v.oy);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(this.bg, 0, 0);
    this.items.forEach(function (it) { self.drawItem(ctx, it); });

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (this.sel && this.mode !== 'measure') {
      var h = this.handles(this.sel);
      ctx.strokeStyle = 'rgba(255,255,255,.95)'; ctx.lineWidth = 1.5; ctx.setLineDash([6, 5]);
      ctx.beginPath(); h.box.forEach(function (p, i) { i ? ctx.lineTo(p.x, p.y) : ctx.moveTo(p.x, p.y); }); ctx.closePath(); ctx.stroke();
      ctx.strokeStyle = 'rgba(0,0,0,.35)'; ctx.lineDashOffset = 5.5; ctx.stroke();
      ctx.setLineDash([]); ctx.lineDashOffset = 0;
      var mid = { x: (h.box[0].x + h.box[1].x) / 2, y: (h.box[0].y + h.box[1].y) / 2 };
      ctx.strokeStyle = 'rgba(255,255,255,.95)'; ctx.beginPath(); ctx.moveTo(mid.x, mid.y); ctx.lineTo(h.rotate.x, h.rotate.y); ctx.stroke();
      this.knob(ctx, h.rotate, 'rot'); this.knob(ctx, h.scale, 'scale');
    }
    if (this.measure) {
      var a = this.toScreen(this.measure.a), b = this.toScreen(this.measure.b);
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(0,0,0,.5)'; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      ctx.strokeStyle = '#f2c14e'; ctx.lineWidth = 3; ctx.stroke();
      [a, b].forEach(function (p) { ctx.fillStyle = '#f2c14e'; ctx.beginPath(); ctx.arc(p.x, p.y, 6, 0, Math.PI * 2); ctx.fill(); });
    }
  };

  DMPlasser.prototype.knob = function (ctx, p, kind) {
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = 6;
    ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(p.x, p.y, HANDLE, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
    ctx.strokeStyle = '#2c4639'; ctx.lineWidth = 2; ctx.beginPath();
    if (kind === 'rot') {
      ctx.arc(p.x, p.y, 6.5, -Math.PI * 0.9, Math.PI * 0.55); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(p.x + 1, p.y + 7.5); ctx.lineTo(p.x - 3.5, p.y + 6.2); ctx.lineTo(p.x - 0.5, p.y + 2.6); ctx.stroke();
    } else {
      ctx.moveTo(p.x - 5, p.y - 5); ctx.lineTo(p.x + 5, p.y + 5);
      ctx.moveTo(p.x + 5, p.y - 1); ctx.lineTo(p.x + 5, p.y + 5); ctx.lineTo(p.x - 1, p.y + 5);
      ctx.moveTo(p.x - 5, p.y + 1); ctx.lineTo(p.x - 5, p.y - 5); ctx.lineTo(p.x + 1, p.y - 5);
      ctx.stroke();
    }
  };

  /* ---------- Berøring og mus ---------- */

  DMPlasser.prototype.pt = function (e) {
    var r = this.canvas.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  DMPlasser.prototype.hitItem = function (sp) {
    var p = this.toImage(sp);
    for (var i = this.items.length - 1; i >= 0; i--) {
      var it = this.items[i], dx = p.x - it.x, dy = p.y - it.y;
      var c = Math.cos(-it.rot), s = Math.sin(-it.rot);
      var lx = dx * c - dy * s, ly = dx * s + dy * c;
      var hw = it.w * it.scale / 2, hh = it.h * it.scale * (1 - it.tilt) / 2;
      if (Math.abs(lx) <= hw && Math.abs(ly) <= hh) {
        // Sjekk at man treffer selve møbelet og ikke en gjennomsiktig flekk
        var u = Math.round((lx / hw * (it.flip ? -1 : 1) + 1) / 2 * it.w);
        var v = Math.round((ly / hh + 1) / 2 * it.h);
        var cv = this.cutouts[it.co].canvas;
        try {
          var a = cv.getContext('2d').getImageData(clamp(u - 6, 0, cv.width - 1), clamp(v - 6, 0, cv.height - 1), 12, 12).data;
          for (var k = 3; k < a.length; k += 4) if (a[k] > 20) return it;
        } catch (err) { return it; }
        if (it === this.sel) return it; // valgt møbel kan dras i hele rammen
      }
    }
    return null;
  };

  DMPlasser.prototype.onDown = function (e) {
    if (!this.bg) return;
    this.canvas.setPointerCapture(e.pointerId);
    var sp = this.pt(e);
    this.pointers[e.pointerId] = sp;
    var ids = Object.keys(this.pointers);

    if (this.mode === 'measure') {
      var ip = this.toImage(sp);
      this.measure = { a: ip, b: ip }; this.drag = { type: 'measure' };
      return;
    }

    if (ids.length === 2 && this.sel) {
      var a = this.pointers[ids[0]], b = this.pointers[ids[1]];
      this.drag = {
        type: 'pinch', d0: Math.hypot(b.x - a.x, b.y - a.y), a0: Math.atan2(b.y - a.y, b.x - a.x),
        s0: this.sel.scale, r0: this.sel.rot, m0: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, x0: this.sel.x, y0: this.sel.y
      };
      return;
    }
    if (ids.length > 1) return;

    if (this.sel) {
      var h = this.handles(this.sel);
      var ctr = this.toScreen({ x: this.sel.x, y: this.sel.y });
      if (Math.hypot(sp.x - h.rotate.x, sp.y - h.rotate.y) < HIT) {
        this.drag = { type: 'rotate', ctr: ctr, a0: Math.atan2(sp.y - ctr.y, sp.x - ctr.x), r0: this.sel.rot }; return;
      }
      if (Math.hypot(sp.x - h.scale.x, sp.y - h.scale.y) < HIT) {
        this.drag = { type: 'scale', ctr: ctr, d0: Math.hypot(sp.x - ctr.x, sp.y - ctr.y), s0: this.sel.scale }; return;
      }
    }
    var it = this.hitItem(sp);
    this.select(it);
    if (it) {
      // Valgt møbel legges øverst
      this.items.splice(this.items.indexOf(it), 1); this.items.push(it);
      this.drag = { type: 'move', sp: sp, x0: it.x, y0: it.y };
    } else this.drag = null;
    this.hint('', 1);
    this.draw();
  };

  DMPlasser.prototype.onMove = function (e) {
    if (!this.pointers[e.pointerId]) {
      // Musepeker: vis riktig markør
      if (this.sel && this.bg && e.pointerType === 'mouse') {
        var sp0 = this.pt(e), h0 = this.handles(this.sel);
        var cur = Math.hypot(sp0.x - h0.rotate.x, sp0.y - h0.rotate.y) < HIT ? 'grab'
          : Math.hypot(sp0.x - h0.scale.x, sp0.y - h0.scale.y) < HIT ? 'nwse-resize'
          : this.hitItem(sp0) ? 'move' : 'default';
        this.canvas.style.cursor = this.mode === 'measure' ? 'crosshair' : cur;
      }
      return;
    }
    var sp = this.pt(e);
    this.pointers[e.pointerId] = sp;
    var d = this.drag, it = this.sel, k = this.view.k;
    if (!d) return;
    if (d.type === 'measure') { this.measure.b = this.toImage(sp); }
    else if (d.type === 'move' && it) { it.x = d.x0 + (sp.x - d.sp.x) / k; it.y = d.y0 + (sp.y - d.sp.y) / k; }
    else if (d.type === 'rotate' && it) {
      var r = d.r0 + Math.atan2(sp.y - d.ctr.y, sp.x - d.ctr.x) - d.a0;
      var deg = r * 180 / Math.PI; if (Math.abs(deg) < 2) r = 0;   // fest til vannrett
      it.rot = r; this.syncUI();
    }
    else if (d.type === 'scale' && it) {
      it.scale = clamp(d.s0 * Math.hypot(sp.x - d.ctr.x, sp.y - d.ctr.y) / (d.d0 || 1), 0.02, 20); this.syncUI();
    }
    else if (d.type === 'pinch' && it) {
      var ids = Object.keys(this.pointers), a = this.pointers[ids[0]], b = this.pointers[ids[1]];
      if (!a || !b) return;
      var dist = Math.hypot(b.x - a.x, b.y - a.y), ang = Math.atan2(b.y - a.y, b.x - a.x);
      var mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      it.scale = clamp(d.s0 * dist / (d.d0 || 1), 0.02, 20);
      it.rot = d.r0 + ang - d.a0;
      it.x = d.x0 + (mid.x - d.m0.x) / k; it.y = d.y0 + (mid.y - d.m0.y) / k;
      this.syncUI();
    }
    this.draw();
  };

  DMPlasser.prototype.onUp = function (e) {
    delete this.pointers[e.pointerId];
    if (this.drag && this.drag.type === 'measure') {
      var m = this.measure, len = m ? Math.hypot(m.b.x - m.a.x, m.b.y - m.a.y) * this.view.k : 0;
      this.drag = null;
      if (len < 20) { this.measure = null; this.draw(); return; }
      var f = this.m.querySelector('.dmp-measure');
      f.hidden = false; this.hint('', 1);
      var inp = f.querySelector('input'); inp.value = ''; setTimeout(function () { inp.focus(); }, 50);
      return;
    }
    var left = Object.keys(this.pointers);
    if (left.length === 1 && this.sel && this.drag && this.drag.type === 'pinch') {
      // Fortsett å dra med fingeren som er igjen
      var sp = this.pointers[left[0]];
      this.drag = { type: 'move', sp: sp, x0: this.sel.x, y0: this.sel.y };
    } else if (!left.length) this.drag = null;
  };

  DMPlasser.prototype.onWheel = function (e) {
    if (!this.sel) return;
    e.preventDefault();
    if (e.shiftKey || e.altKey) this.sel.rot += (e.deltaY > 0 ? 1 : -1) * Math.PI / 90;
    else this.sel.scale = clamp(this.sel.scale * Math.exp(-e.deltaY * 0.0015), 0.02, 20);
    this.syncUI(); this.draw();
  };

  DMPlasser.prototype.key = function (e) {
    if (e.key === 'Escape') {
      if (this.mode === 'measure') { this.action('measure-cancel'); return; }
      this.close(); return;
    }
    if (e.target && /INPUT|TEXTAREA/.test(e.target.tagName) && e.target.type !== 'range') return;
    var it = this.sel; if (!it) return;
    var step = (e.shiftKey ? 20 : 4) / (this.view ? this.view.k : 1), used = true;
    switch (e.key) {
      case 'ArrowLeft': it.x -= step; break;
      case 'ArrowRight': it.x += step; break;
      case 'ArrowUp': it.y -= step; break;
      case 'ArrowDown': it.y += step; break;
      case '+': case '=': it.scale *= 1.04; break;
      case '-': it.scale /= 1.04; break;
      case 'r': it.rot += Math.PI / 90; break;
      case 'R': it.rot -= Math.PI / 90; break;
      case 'Delete': case 'Backspace': this.action('delete'); break;
      default: used = false;
    }
    if (used) { e.preventDefault(); this.syncUI(); this.draw(); }
  };

  /* ---------- Lagre og dele ---------- */

  DMPlasser.prototype.exportImage = function (share) {
    if (!this.bg) return;
    var self = this, bg = this.bg;
    var c = document.createElement('canvas'); c.width = bg.width; c.height = bg.height;
    var x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(bg, 0, 0);
    this.items.forEach(function (it) { self.drawItem(x, it); });
    // Liten merking nede i hjørnet
    var fs = Math.max(14, Math.round(bg.width / 70)), pad = fs * 0.8;
    var label = (this.cfg.title ? this.cfg.title + ' · ' : '') + 'drommemobler.no';
    x.font = '600 ' + fs + 'px system-ui, -apple-system, sans-serif';
    var tw = x.measureText(label).width;
    x.fillStyle = 'rgba(0,0,0,.45)';
    x.fillRect(bg.width - tw - pad * 3, bg.height - fs - pad * 2.4, tw + pad * 2, fs + pad * 1.4);
    x.fillStyle = '#fff'; x.textBaseline = 'middle';
    x.fillText(label, bg.width - tw - pad * 2, bg.height - pad * 1.7 - fs / 2);

    var name = 'min-terrasse-' + (this.cfg.handle || 'drommemobler') + '.jpg';
    c.toBlob(function (blob) {
      if (!blob) return;
      if (share && navigator.share) {
        var file = new File([blob], name, { type: 'image/jpeg' });
        navigator.share({ files: [file], title: self.cfg.title || 'Drømmemøbler', text: (self.cfg.title || 'Møbelet') + ' på terrassen vår' + (self.cfg.url ? ' – ' + self.cfg.url : '') })
          .catch(function () {});
        return;
      }
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = name;
      document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }, 'image/jpeg', 0.9);
  };

  window.DMPlasser = DMPlasser;

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dm-plasser]:not([data-dmp-ready])'), function (root) {
      root.setAttribute('data-dmp-ready', '');
      var cfg = {};
      try { cfg = JSON.parse(root.getAttribute('data-dm-plasser') || '{}'); } catch (e) {}
      if (!cfg.images || !cfg.images.length) return;
      root._dmp = new DMPlasser(root, cfg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
